import { Injectable, Pipe } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Pipe({ name: 'EmailService' })

@Injectable()
export class EmailService {

  constructor(private httpClient: HttpClient) { }

  sendEmailAfterEditPic(picId, currentUserId, leadId, contactId, currentUrl, empCCIdList, potentialName, statusName, picName) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/email/sendEmailAfterEditPic";
    return this.httpClient.post(url, {
        PicId: picId, UserId: currentUserId, LeadId: leadId, ContactId: contactId, CurrentUrl: currentUrl, EmpCCIdList: empCCIdList,
        PotentialName: potentialName, StatusName: statusName, PicName: picName
    })
      .map((response: Response) => {
        return response;
      });
  }
  
  sendEmailAfterCreatedLead(currentUsername, currentUserEmail, currentUrl, userId, leadId) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/email/sendEmailAfterCreatedLead";
    return this.httpClient.post(url, { CurrentUsername: currentUsername, CurrentUserEmail: currentUserEmail, CurrentUrl: currentUrl, UserId: userId, LeadId: leadId })
      .map((response: Response) => {
        return response;
      });
  }

  sendEmailAfterCreateNote(employeeIdList, currentUsername, currentUrl, userId, leadId, noteContent, fileNameArray) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/email/sendEmailAfterCreateNote";
    return this.httpClient.post(url, {
      CurrentUsername: currentUsername, EmployeeIdList: employeeIdList, CurrentUrl: currentUrl,
      UserId: userId, LeadId: leadId, NoteContent: noteContent, FileNameArray: fileNameArray
    })
      .map((response: Response) => {
        return response;
      });
  }
  sendEmailEmployeePayslip(lstEmpMonthySalary: Array<string>) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/email/sendEmailEmployeePayslip";
    return this.httpClient.post(url, { lstEmpMonthySalary: lstEmpMonthySalary})
      .map((response: Response) => {
        return response;
      });
  }
  sendEmailTeacherPayslip(lstEmpMonthySalary: Array<string>) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/email/sendEmailTeacherPayslip";
    return this.httpClient.post(url, { lstEmpMonthySalary: lstEmpMonthySalary })
      .map((response: Response) => {
        return response;
      });
  }
  sendEmailAssistantPayslip(lstEmpMonthySalary: Array<string>) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/email/sendEmailAssistantPayslip";
    return this.httpClient.post(url, { lstEmpMonthySalary: lstEmpMonthySalary })
      .map((response: Response) => {
        return response;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/email.service.ts